import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useLivePageMode } from '@confluence/live-pages-utils/entry-points/useLivePagesStore.ts';

/**
 * Whether the Suggestions panel is open on a live doc in view mode. The editor stays mounted, so
 * suggestions are read from it, but they are listed read-only as on a published page.
 */
export const useIsLiveDocViewMode = (): boolean => {
	const isLivePage = useIsCurrentPageLive();
	const [{ isViewMode }] = useLivePageMode();

	return (
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning -- The suggested edits experiment is the kill switch for the view mode Suggestions panel subgate.
		isLivePage &&
		isViewMode &&
		expValEquals('platform_editor_ai_content_suggested_edits', 'isEnabled', true) &&
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- View mode Suggestions panel subgate.
		fg('confluence_suggestions_panel_view_mode')
	);
};
